
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateIndicatorResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseObj"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"indicator_response_set_input"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_indicator_response_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseObj"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checklists"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compliance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"indicator_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"non_compliance_statement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nc_status_created_by_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"non_compliance_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refer_to_ca"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"non_conformity_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"observation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk_impact"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk_likelihood"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk_rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"risk_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_marked_complete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"further_action_required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviewed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_closed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_updated_by_id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":634}};
    doc.loc.source = {"body":"mutation updateIndicatorResponse($responseId: Int!, $responseObj: indicator_response_set_input!) {\n    update_indicator_response_by_pk(pk_columns: {id: $responseId}, _set: $responseObj) {\n        checklists\n        compliance\n        id\n        indicator_id\n        non_compliance_statement\n        nc_status_created_by_id\n        non_compliance_type\n        refer_to_ca\n        non_conformity_status\n        observation\n        risk_impact\n        risk_likelihood\n        risk_rating\n        risk_type\n        is_marked_complete\n        further_action_required\n        reviewed\n        date_closed\n        last_updated_by_id\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["updateIndicatorResponse"] = oneQuery(doc, "updateIndicatorResponse");
        
